function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7151",
  "data-name": "Group 7151",
  transform: "translate(-400.852 -239.353)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5706",
  "data-name": "Group 5706",
  transform: "translate(472.477 376.913)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5372",
  "data-name": "Rectangle 5372",
  width: 40.665,
  height: 4.894,
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3442",
  "data-name": "Path 3442",
  d: "M50.156,120.375a15.061,15.061,0,0,0-14.821,12.539h-.226a25.078,25.078,0,1,1,0-50.156h2.734a15.029,15.029,0,0,0,29.642,0h25.53a15.029,15.029,0,0,0,29.642,0h2.734a30.094,30.094,0,1,0,0-60.187H105.1a15.029,15.029,0,0,0-29.642,0H55.172V2.508A2.507,2.507,0,0,0,52.664,0H2.508A2.507,2.507,0,0,0,0,2.508V42.633A2.507,2.507,0,0,0,2.508,45.14H52.664a2.507,2.507,0,0,0,2.508-2.508V27.586H75.46a15.029,15.029,0,0,0,29.642,0h20.288a25.078,25.078,0,1,1,0,50.156h-2.734a15.029,15.029,0,0,0-29.642,0H67.485a15.029,15.029,0,0,0-29.642,0H35.109a30.094,30.094,0,1,0,0,60.187h.226a15.029,15.029,0,0,0,29.642,0h5.241v-5.016H64.978A15.061,15.061,0,0,0,50.156,120.375ZM25.078,5.016h5.016V15.047H25.078ZM50.156,40.125H5.016V5.016H20.063V17.555a2.507,2.507,0,0,0,2.508,2.508H32.6a2.507,2.507,0,0,0,2.508-2.508V5.016H50.156Zm40.125-5.016a10.031,10.031,0,1,1,10.031-10.031A10.041,10.041,0,0,1,90.282,35.109Zm17.555,35.109A10.031,10.031,0,1,1,97.8,80.25,10.041,10.041,0,0,1,107.836,70.219Zm-55.172,0A10.031,10.031,0,1,1,42.633,80.25,10.041,10.041,0,0,1,52.664,70.219Zm-2.508,75.234a10.031,10.031,0,1,1,10.031-10.031A10.041,10.041,0,0,1,50.156,145.453Z",
  transform: "translate(403.572 243.997)"
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(555.507 333.777)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M14.847,2A12.847,12.847,0,1,0,27.694,14.847,12.847,12.847,0,0,0,14.847,2Zm7.292,10.582-7.708,7.066a1.285,1.285,0,0,1-1.777-.039L8.8,15.755a1.285,1.285,0,1,1,1.817-1.817L13.6,16.923l6.8-6.235a1.285,1.285,0,0,1,1.737,1.894Z",
  transform: "translate(-2 -2)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3424",
  "data-name": "Path 3424",
  d: "M11233.17,20190.125l-26.6,21.8v34.02h53.705v-33.25Z",
  transform: "translate(-10693.431 -19838.365)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3423",
  "data-name": "Path 3423",
  d: "M0,0,21.172,15.135",
  transform: "matrix(-0.259, 0.966, -0.966, -0.259, 530.316, 349.501)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5538",
  "data-name": "Rectangle 5538",
  width: 60.809,
  height: 53.957,
  transform: "translate(400.852 241.493)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251",
  transform: "translate(421.969 239.353)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398",
  "data-name": "Path 3398",
  d: "M54.971,18.913a1.143,1.143,0,0,0-.326-.8L41.533,4.743a1.143,1.143,0,0,0-.817-.343H21a5.716,5.716,0,0,0-5.716,5.716V50.83A5.716,5.716,0,0,0,21,56.546H49.255a5.716,5.716,0,0,0,5.716-5.716ZM41.767,8.235,51.65,18.318H43.482A1.715,1.715,0,0,1,41.767,16.6Zm7.488,46.024H21a3.43,3.43,0,0,1-3.43-3.43V10.1A3.43,3.43,0,0,1,21,6.669H39.481V16.6a4,4,0,0,0,4,4h9.2V50.83A3.43,3.43,0,0,1,49.255,54.259Z",
  transform: "translate(-15.28 -4.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399",
  "data-name": "Path 3399",
  d: "M57.1,48.26h-15.4a1.143,1.143,0,1,0,0,2.286H57.1a1.143,1.143,0,1,0,0-2.286Z",
  transform: "translate(-26.106 -23.19)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400",
  "data-name": "Path 3400",
  d: "M29.215,47.26a1.715,1.715,0,1,0,0,3.43h.029a1.715,1.715,0,1,0-.029-3.43Z",
  transform: "translate(-20.515 -22.762)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401",
  "data-name": "Path 3401",
  d: "M57.1,61.26h-15.4a1.143,1.143,0,1,0,0,2.286H57.1a1.143,1.143,0,0,0,0-2.286Z",
  transform: "translate(-26.106 -28.76)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402",
  "data-name": "Path 3402",
  d: "M29.215,60.26a1.715,1.715,0,1,0,0,3.43h.029a1.715,1.715,0,1,0-.029-3.43Z",
  transform: "translate(-20.515 -28.331)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403",
  "data-name": "Path 3403",
  d: "M57.1,74.26h-15.4a1.143,1.143,0,0,0,0,2.286H57.1a1.143,1.143,0,0,0,0-2.286Z",
  transform: "translate(-26.106 -34.329)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404",
  "data-name": "Path 3404",
  d: "M29.215,73.26a1.715,1.715,0,1,0,0,3.43h.029a1.715,1.715,0,1,0-.029-3.43Z",
  transform: "translate(-20.515 -33.9)"
})));

function SvgStepper5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.349,
    height: 170.23,
    viewBox: "0 0 180.349 170.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper5);
export default __webpack_public_path__ + "static/media/stepper5.6ef10394b682a87d33a21f4446388891.svg";
export { ForwardRef as ReactComponent };